'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import bowser from '../../vendor/bowser.min';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { withRouter } from 'react-router-dom';
import { parse as parseQuery } from 'hub-http/helpers/params';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
const SUPPORTED_BROWSERS = {
  chrome: '32',
  chromium: '32',
  firefox: '28',
  msedge: '12',
  msie: '11',
  safari: '6.1'
};
const HUBSPOT_ANDROID_UA = /^HubSpotAndroid\//;
const HUBSPOT_IOS_UA = /^HubSpotiOS\//;
const ZOOM_WEB_KIT_UA = /ZoomWebKit\//;

class BrowserVersionWrapper extends Component {
  constructor(props) {
    super(props);

    this.renderOutdatedBrowser = (browserName, browserVersion) => {
      return /*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "unsupported-browser-image"
        }), /*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.header"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "m-bottom-4",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.instructions",
            options: {
              browserName,
              browserVersion
            }
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          href: "https://knowledge.hubspot.com/articles/KCS_Article/Resources/Which-browsers-are-supported-by-HubSpot",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.button"
          })
        })]
      });
    };

    this.renderUnrecognizedBrowser = browserName => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIAlert, {
          className: "m-bottom-4",
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.unrecognizedBrowser",
            options: {
              browserName
            }
          })
        }), this.props.children]
      });
    };

    const {
      search
    } = props.location;
    const query = parseQuery(search.substr(1));
    const {
      isOutlook
    } = query;
    const {
      name: _browserName,
      version: _browserVersion
    } = bowser;
    const isOutdatedBrowser = bowser.isUnsupportedBrowser(SUPPORTED_BROWSERS, false);
    const isUnknownBrowser = bowser.isUnsupportedBrowser(SUPPORTED_BROWSERS, true);
    const userAgent = typeof window.navigator !== 'undefined' ? window.navigator.userAgent || '' : '';
    const isHubSpotMobile = HUBSPOT_ANDROID_UA.test(userAgent) || HUBSPOT_IOS_UA.test(userAgent);
    const isZoom = ZOOM_WEB_KIT_UA.test(userAgent);
    this.state = {
      browserName: _browserName,
      browserVersion: _browserVersion,
      isHubSpotMobile,
      isOutdatedBrowser,
      isOutlook,
      isUnknownBrowser,
      isZoom
    };
  }

  render() {
    const {
      browserName,
      browserVersion,
      isHubSpotMobile,
      isOutdatedBrowser,
      isOutlook,
      isUnknownBrowser,
      isZoom
    } = this.state;

    if (!isOutlook && !isHubSpotMobile && !isZoom) {
      if (isOutdatedBrowser) {
        return this.renderOutdatedBrowser(browserName, browserVersion);
      } else if (isUnknownBrowser) {
        return this.renderUnrecognizedBrowser(browserName);
      }
    }

    return this.props.children;
  }

}

export default withRouter(BrowserVersionWrapper);